import { SphereIconButton } from "@components/common/sphere-icon-button";
import { SphereBreadcrumbs } from "@components/header/sphere-breadcrumbs";
import { HamburgerMenuIcon, FontWeights } from "@flat-ui";
import { Box, Grid } from "@mui-wrapper";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { sidebarSelector } from "@store/ui/ui-selector";
import { updateSidebar } from "@store/ui/ui-slice";
import { DEFAULT_TITLE_FONT_SIZE } from "@styles/common-styles";
import { useMediaQueryList } from "@hooks/use-media-query";
/** Content for the left side of layout header */
export function HeaderLayoutLeft({
  shouldHideOpenButton,
  topLeftHeaderButton,
  shouldShowSidebar,
  shouldShowBreadcrumbs = true
}) {
  const dispatch = useAppDispatch();
  const sidebar = useAppSelector(sidebarSelector);
  const {
    isScreenSmOrLarger
  } = useMediaQueryList();
  useEffect(() => {
    dispatch(updateSidebar({
      ...sidebar,
      isVisible: shouldShowSidebar
    }));
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Putting sidebar on dependency will create a loop
  }, [dispatch, shouldShowSidebar]);
  return <Grid container sx={{
    alignItems: "center",
    flexGrow: 1,
    flexBasis: 0,
    // The AppBar has a fixed height, so the row shrinks rather than wrapping.
    flexWrap: "nowrap",
    minWidth: 0
  }}>
      {/* Large button to show on the left side of header */}
      {topLeftHeaderButton}

      {/* Button to open drawer */}
      {!isScreenSmOrLarger && !shouldHideOpenButton && shouldShowSidebar && <Grid sx={{
      alignItems: "center"
    }}>
          <Box component="div" sx={{
        color: "text.primary",
        fontWeight: FontWeights.SemiBold,
        fontSize: DEFAULT_TITLE_FONT_SIZE,
        lineHeight: "28px",
        letterSpacing: "0.16px"
      }}>
            <SphereIconButton iconButtonProps={{
          // SphereIconButton only forwards the props it declares, so the label has
          // to go through iconButtonProps to reach the button element.
          "aria-label": "open drawer",
          sx: {
            // Replaces MUI's IconButton-only edge="start", which pulled the button
            // 12px to the left so its padding does not offset it from the edge.
            ml: -1.5,
            mr: 2,
            display: {
              sm: "none"
            }
          }
        }} component={HamburgerMenuIcon} iconSize="20px" onClick={() => {
          dispatch(updateSidebar({
            isOpenOnMobile: true
          }));
        }} />
          </Box>
        </Grid>}

      {shouldShowBreadcrumbs && <Grid sx={{
      alignItems: "center",
      minWidth: 0
    }}>
          <SphereBreadcrumbs />
        </Grid>}
    </Grid>;
}